import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  cardDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  }
}))
